import ru from 'date-fns/locale/ru';

const fnsLocales = {
  en: null,
  ru,
};

export const getFnsLocale = (ln) => fnsLocales[ln] || null;
